import { gql, MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import { Trigger } from 'store/trigger'

interface Data {
  status: {
    message: string
    triggers?: Array<Omit<Trigger, 'id'>>
  }
}

interface Variables {
  activity: string
  company?: string
  payload?: string
}

const MUTATION = gql`
    mutation registerProfileActivity($activity: String!, $company: ID, $payload: String) {
        status: registerProfileActivity(activity: $activity, company: $company, payload: $payload) {
            message
            triggers {
              type
              payload
            }
        }
    }
`

export const useRegisterProfileActivityMutation = (
  options?: MutationHookOptions<Data, Variables>,
): MutationTuple<Data, Variables> => useMutation<Data, Variables>(MUTATION, options)
